interface CircleProps {
	className?: string;
}

const Circle = ({ className }: CircleProps) => {
	return (
		<span className={`${className}`}>
			<svg
				width="160"
				height="115"
				viewBox="0 0 168 75"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<title>Decorative circle</title>
				<path
					className="fill-primary opacity-20"
					d="M108.4,55.4c2.2-2.3,5-5.7,6.4-10.9,6-27.9-26.4-37.9-38.5-41.7-.9-.3-1.6-.5-2.3-.7C66.1,0,58.2-.5,49.7.4c-1.6.2-3.2.3-4.7.5-3.1.3-6.4.6-9.5,1.1-1.9.5-3.8,1.2-5.7,2.2.9.2,1.8.4,2.8.5l4.5.6-4.6.4C24.3,6.4.6,12.9,0,32.7v.2c0,11.4,7.5,17.5,11.4,20.8,14.3,10.5,29.7,12.4,45.6,13.6,10.5.6,21-.1,31.2-2.2h.6c6.7-1.8,13.6-3.5,19.6-9.7ZM87.6,62l-1.1.2c-6.9,1.4-14.2,2-22.2,2s-5.4,0-8.2-.2c-13.2-1-27.1-2.7-40.2-10.6l-.5-.3c-4.8-3.2-12.8-8.6-14.1-18.6h-.1v-.5c-.4-8.8,5.8-13.7,9.5-16.6l.8-.6c16.5-11.2,33.8-8.7,53.2-4.6.5,0,1,.1,1.6.2,1.4.2,2.9.3,4.3.7-2.5-2.7-5.3-3.8-7.8-4.5-7.1-1.7-14.4-2.6-22.5-2.9v-1c11.7-1.5,23.3-2.5,34.8.9l1.4.4c10.7,3.4,28.7,9,35.9,23,2.9,5.7,2.8,13.2-.4,18.4-6.8,10.8-16.1,12.8-24.4,14.5Z"
				/>
			</svg>
		</span>
	);
};

export default Circle;
